import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useTourStore = create(
    persist(
        (set, get) => ({
            isTourActive: false,
            tourMode: null, // 'marketplace' | 'crm' | null
            stepIndex: 0,
            isFinished: false,
            isCompletedSuccessfully: false,
            successModalSeen: false,

            // Actions
            startTour: (mode) => set({
                isTourActive: true,
                tourMode: mode,
                stepIndex: 0
            }),

            stopTour: () => set({
                isTourActive: false
            }),

            finishTour: () => set({
                isTourActive: false,
                isFinished: true,
                stepIndex: 0
            }),

            completeTour: () => set({
                isTourActive: false,
                isFinished: true,
                isCompletedSuccessfully: true,
                stepIndex: 0
            }),

            closeSuccessModal: () => set({
                successModalSeen: true
            }),

            setStepIndex: (index) => set({ stepIndex: index }),

            skipTour: () => set({
                isTourActive: false,
                isFinished: true,
                tourMode: null
            }),

            resetTour: () => set({
                isTourActive: false,
                tourMode: null,
                stepIndex: 0,
                isFinished: false,
                isCompletedSuccessfully: false,
                successModalSeen: false
            })
        }),
        {
            name: 'tablecrm-tour-storage', // name of item in the storage (must be unique)
        }
    )
);
